import { jsx as _jsx } from "react/jsx-runtime";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { CartProvider } from "@/core/context/CartContext";
import "./styles/global/index.css";
ReactDOM.render(_jsx(Router, { children: _jsx(CartProvider, { children: _jsx(App, {}) }) }), document.getElementById("root"));
